
@if (loading) {
  <app-loader/>
}

<div class="ed-dialog-content" #content></div>

<ng-template #close>
  <app-icon (click)="closeDialog()">close</app-icon>
</ng-template>
